import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "main-m" }
const _hoisted_2 = { class: "container" }

import { NConfigProvider, GlobalThemeOverrides } from "naive-ui";
import { zhCN, dateZhCN } from "naive-ui";
import Nav from "componentsM/Nav/index.vue";
import backBtn from "componentsM/back-btn/index.vue";
import { useRoute } from "vue-router";
import {} from "vue";
import themeOverrides from "config/themeOverrides";

// console.log(parentRouteFilter(localRoutes));


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(NConfigProvider), {
    "theme-overrides": _unref(themeOverrides),
    locale: _unref(zhCN),
    "date-locale": _unref(dateZhCN)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Nav),
        _createVNode(backBtn),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_view)
        ])
      ])
    ]),
    _: 1
  }, 8, ["theme-overrides", "locale", "date-locale"]))
}
}

})